import script from "./ButtonAccentTertiary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonAccentTertiary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonAccentTertiary.vue?vue&type=style&index=0&id=280d267d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-280d267d"]])

export default __exports__